import React from "react";

const ROLE_LABEL = {
  super_admin: "Super Admin",
  leasing_sales: "Leasing / Sales",
  ops_dispatch: "Ops / Dispatch",
  accounting: "Accounting",
  maintenance: "Maintenance",
  driver: "Driver",
};

export const RoleBadge = ({ role }) => {
  const isSuper = role === "super_admin";
  const label = ROLE_LABEL[role] || role;
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-medium tracking-wide " +
        (isSuper
          ? "bg-deep-road-navy text-white border border-touring-lime"
          : "bg-coach-blue text-white border border-coach-blue")
      }
    >
      {label}
    </span>
  );
};
